module.exports = __webpack_public_path__ + "img/sand_clock.85da1a4f.svg";